import { Spinner } from "src/primitives/Spinner";

export const LoadingOverlay = () => (
  <div className="absolute inset-0 z-10 flex items-center justify-center bg-background/50">
    <Spinner className="size-6" />
  </div>
);
